
import './IssueSkeleton.scss';

const IssueSectionSkeleton = ({ itemsCount = 6, subCount = 4 }) => {

  return (
    <div className="issue__services__section__skeleton">
      <div className="left__side__issue__services__section__skeleton">
        <div className="services__issue__content__skeleton">
          <div className="services__issue__accent__skeleton"></div>
          {[...Array(2)].map((_, i) => (
            <div key={i} className="services__issue__title__skeleton"></div>
          ))}
          <div className="services__issue__title__skeleton--primary"></div>
          {[...Array(subCount)].map((_, i) => (
            <div key={i} className="services__issue__subtitle__skeleton"></div>
          ))}
          <div className="services__issue__subtitle__skeleton--primary"></div>
          <div className="services__issue__button__skeleton">
          </div>
        </div>
      </div>
      <div className="right__side__issue__services__section__skeleton">
        {[...Array(itemsCount)].map((_, i) => (
          <div key={i} className="services__issue__links__item__skeleton">
            <div className="issue__icon__skeleton">
              <div className="issue__icon__skeleton"></div>
            </div>
            <div className="issue__link__item__skeleton"></div>
            <div className="issue__link__item__skeleton--primary"></div>
            {[...Array(4)].map((_, i) => (
              <div key={i} className="services__issue__link__text__skeleton"></div>
            ))}
            <div className="services__issue__link__text__skeleton--primary"></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IssueSectionSkeleton;